import { useTranslation } from 'react-i18next';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';
import { ButtonSelect } from '../button-select';
import { SetStateAction, useEffect } from 'react';
import { ContentView } from 'src/features/statistics/types/content-view';
import { SetSortController } from 'src/hooks/use-sort-controller';
import { SortOrder } from 'src/types/enum/sort-order';
import { MeiliSearchSearchState } from 'src/hooks/meilisearch/types/meilisearch-search-state';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
  handleChangeSort: (
    newSort: string[],
    defaultSearchStateConfig?: Partial<MeiliSearchSearchState>,
  ) => void;
  contentView: ContentView;
  setContentView: React.Dispatch<SetStateAction<ContentView>>;
  setSortController: SetSortController;
}

const items: {
  value: string;
  label: string;
  color?: string;
}[] = [];

const contentViewFilterGroup: FilterGroup<string> = {
  id: 5,
  type: 'contentView',
  label: '',
  singleOption: true,
  filterOperator: 'custom',
  items,
};

export const ContentViewFilterSelect = ({
  filters,
  handleChangeFilterValue,
  handleChangeSort,
  contentView,
  setContentView,
  setSortController,
}: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (contentView === 'CHART') {
      handleChangeSort([`date:${SortOrder.ASC}`]);
      setSortController({
        sortBy: 'date',
        sortOrder: SortOrder.ASC,
      });
    }
  }, [contentView]);

  return (
    <ButtonSelect
      items={[
        {
          text: t('statistics:common.contentView.table'),
          onClick: () => {
            toggleFilterItemSelection(
              contentViewFilterGroup.type,
              'TABLE',
              contentViewFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              contentViewFilterGroup.filterOperator,
            );
            setContentView('TABLE');
          },
        },
        {
          text: t('statistics:common.contentView.chart'),
          onClick: () => {
            toggleFilterItemSelection(
              contentViewFilterGroup.type,
              'CHART',
              contentViewFilterGroup.singleOption,
              filters,
              handleChangeFilterValue,
              contentViewFilterGroup.filterOperator,
            );
            setContentView(prev => (prev === 'TABLE' ? 'CHART' : 'TABLE'));
          },
        },
      ]}
      variant="outlinedContained"
      size="large"
      sx={{
        color: 'text.primary',
        fontWeight: '400',
        mr: 2,
      }}>
      {t(`statistics:common.contentView.${contentView.toLowerCase()}`)}
    </ButtonSelect>
  );
};
